<p>cv-admin-awards works!</p>
